function SignatureUrl(userId: string, signature: string, dateFilter?: string): string {
  const url = "/surfwize/reporting/type/" + signature + "/user/" + userId + "?show_blocked=true&hits=true";
  if (dateFilter) {
    return url + "&" + dateFilter;
  }
  return url;
}

function SuicideUrl(userId: string, dateFilter?: string): string {
  const url = "/cybersafety/search/user/" + userId + "/suicide";
  if (dateFilter) {
    return url + "?" + dateFilter;
  }
  return url;
}

function SearchUrl(userId: string, searchId: string, dateFilter?: string): string {
  const url = "/cybersafety/search/user/" + userId + "/" + searchId;
  if (dateFilter) {
    return url + "?" + dateFilter;
  }
  return url;
}

export { SuicideUrl, SearchUrl, SignatureUrl };
